import React, { ReactNode } from 'react';
import './AppLayout.scss';

interface IProps {
  children: ReactNode;
}

class AppLayout extends React.Component<IProps> {

  render() {
    return (
      <div id="app-layout">
        {this.props.children}
      </div>
    );
  }
}

export default AppLayout;
